import * as React from 'react';
import { connect } from 'react-redux';

import { fetchInfluencersMeta } from 'modules/influencers/reducers/influencersMeta';

import { influencerMetaSelector } from 'selectors/influencersMeta';

import type { InfluencerMeta } from 'types';

type OwnProps = {
  influencerProfile: {
    id: number
  }
};

type StateProps = {
  influencerMeta: InfluencerMeta
};

type DispatchProps = {
  dispatchFetchInfluencersMeta: (a: number) => void
};

type InjectedProps = StateProps & DispatchProps;

// COLLAB-10801 – not sure why do we have double function here, but let's stick to this variant for now
const withInfluencerMeta = () =>
  <T extends OwnProps>(ChildComponent: React.ComponentType<T>) => {
    type Props = OwnProps & InjectedProps;

    const WrappedComponent = (props: Props & T) => {
      const { dispatchFetchInfluencersMeta, influencerMeta, influencerProfile } = props;

      React.useEffect(() => {
        if (dispatchFetchInfluencersMeta) {
          dispatchFetchInfluencersMeta(influencerProfile.id);
        }
      }, [dispatchFetchInfluencersMeta, influencerProfile.id]);

      return <ChildComponent {...props as (Props & T)} influencerMeta={influencerMeta} />;
    };

    const mapStateToProps = (state, { influencerProfile: { id } }): StateProps => ({
      influencerMeta: influencerMetaSelector(state, { influencerId: id })
    });

    const mapDispatchToProps = (dispatch): DispatchProps => ({
      dispatchFetchInfluencersMeta: (id: number) => dispatch(fetchInfluencersMeta([id]))
    });

    return connect(
      mapStateToProps,
      mapDispatchToProps
      // @ts-ignore JSX.Element is not assignable to type FunctionComponent
    )(WrappedComponent);
  };


export default withInfluencerMeta;
